/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CourseAnalyticsDash from "../../components/CourseAnalyticsDash";
import Navbar from "../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const CourseAnalytics = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.courseAnalytics?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <CourseAnalyticsDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CourseAnalytics;
